import { oc } from '@orpc/contract';
import { addServiceEventInputSchema, listServiceEventsOutputSchema } from '../schemas/history.schemas.js';
/**
 * Record a past job. Allowed on a **sold** vehicle as well as an open one: evidence about a car's
 * history does not stop being true when the car leaves the yard (plan §5.6, §8).
 */
export const addServiceEventContract = oc
    .route({
    method: 'POST',
    path: '/vehicles/{vehicleId}/history',
    tags: ['History'],
    summary: 'Record a historical service event',
})
    .input(addServiceEventInputSchema)
    .output(listServiceEventsOutputSchema);
//# sourceMappingURL=add-service-event.contract.js.map